import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';

const EmptyState = ({ 
  icon: Icon = InboxOutlined,
  title = 'No hay datos', 
  description = 'No se encontraron registros para mostrar.',
  actionLabel,
  onAction,
  size = 'medium'
}) => {
  const sizes = {
    small: { iconSize: 48, spacing: 1 },
    medium: { iconSize: 64, spacing: 2 },
    large: { iconSize: 80, spacing: 3 }
  };

  const s = sizes[size] || sizes.medium;

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      py: 8,
      px: 2,
      textAlign: 'center'
    }}>
      <Icon sx={{ fontSize: s.iconSize, color: 'grey.400', mb: s.spacing }} />
      <Typography variant="h6" fontWeight={500} color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.disabled" mb={actionLabel ? 3 : 0} maxWidth={400}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="outlined" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;